import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import Router from "vue-router";
import config from "@/config";

Vue.use(Vuex);
Vue.use(Router);

export default new Vuex.Store({
  state: {
    productCategories: {},
    products: {},
    product: {},
    productImages: {},
    currentLanguage: localStorage.getItem("language"),
    locales: {}
  },
  getters: {
    getProductCategories: state => state.productCategories,
    getProducts: state => state.products,
    getProduct: state => state.product,
    getProductImages: state => state.productImages,
    getCurrentLanguage: state => state.currentLanguage,
    getLocales: state => state.locales
  },
  mutations: {
    setProductCategories: (state, payload) => {
      state.productCategories = payload;
    },
    setProducts: (state, payload) => {
      state.products = payload;
    },
    setProduct: (state, payload) => {
      state.product = payload;
    },
    setProductImages: (state, payload) => {
      state.productImages = payload;
    },
    setCurrentLanguage: (state, payload) => {
      state.currentLanguage = payload;
    },
    setLocales: (state, payload) => {
      state.locales = payload;
    }
  },
  actions: {
    setLanguage: (context, payload) => {
      context.commit("setCurrentLanguage", payload);
      localStorage.setItem("language", payload);
    },
    fetchLocales: (context) => {
      axios.get(`${config.API_ROOT}/locales`)
        .then((request) => { context.commit("setLocales", request.data); });
    },
    fetchProductCategories: (context) => {
      if (context.getters.getCurrentLanguage == null) {
        context.commit("setCurrentLanguage", "en-gb");
      }
      axios.get(`${config.API_ROOT}/categories`, { headers: { "x-locale": context.getters.getCurrentLanguage } })
        .then((request) => { context.commit("setProductCategories", request.data); });
    },
    fetchProducts: (context, payload) => {
      if (payload === "0") {
        axios.get(`${config.API_ROOT}/products`, { headers: { "x-locale": context.getters.getCurrentLanguage } })
          .then((request) => { context.commit("setProducts", request.data.products); });
      } else {
        axios.get(`${config.API_ROOT}/categories/${payload}/products`, { headers: { "x-locale": context.getters.getCurrentLanguage } })
          .then((request) => { context.commit("setProducts", request.data.category.products); });
      }
    },
    fetchProduct: (context, payload) => {
      axios.get(`${config.API_ROOT}/products/${payload}`, { headers: { "x-locale": context.getters.getCurrentLanguage } })
        .then((request) => { context.commit("setProduct", request.data.product); });
    }
  }
});
